import { createService } from '@bonanza-social/toolkit/api';
import { RegistrationOffersResponseSchema } from './RegistrationOffersService.schemas';

export default createService({
  getRegistrationOffers: {
    method: 'GET',
    url: '/Lobby/promotions',
    responseSchema: RegistrationOffersResponseSchema,
    headers: {
      'X-Feature-EnableMetaGameRewards': 'true',
    },
  },
});
